<header>
  <!-- phone-order-mode -->
  <phone-order></phone-order>
  <!-- /phone-order-mode -->
  <!-- header-cms -->
  @if (cmsTitle) {
    <cms [title]="cmsTitle" #cmsComp></cms>
  }
  <!-- end header-cms -->
  <!-- components-to-replace -->
  <section #containerRef [hidden]="true">
    @if (!shareSvc.isMobileMode()) {
      <dropdown-langs></dropdown-langs>
      <!--<main-header-search-form></main-header-search-form>-->
      <!--<search></search>-->
      <user-login></user-login>
      <main-top-navigation></main-top-navigation>
    } @else {
      @if (!isRestricted) {
        <main-header-navbar-mobile></main-header-navbar-mobile>
      }
    }
  </section>
  <!-- end components-to-replace -->
</header>
